import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  InputGroup,
  Button,
  FormControl,
} from 'react-bootstrap';
import { required, email } from '../../../forms';

export const renderBootstrapField = ({ input, label, type, placeholder, meta: { touched, error, warning } }) => (
  <InputGroup>
    <FormControl
      {...input}
      type={type}
      label={label}
      placeholder={placeholder}
    />
    {touched &&
      ((error && <span>{error}</span>) ||
        (warning && <span>{warning}</span>))}
  </InputGroup>
);

const RegisterHotelForm = ({ onSubmit, initialValues }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={(values) => {
      const errors = {};
      if (!values.name) {
        errors.FORM_ERROR = 'Hotel name must not be blank.';
      }
      return errors;
    }}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => (
      <div>
        <form onSubmit={handleSubmit}>
          <Field
            name="email"
            type="input"
            component={renderBootstrapField}
            label="email"
            placeholder="Email"
            validate={email}
          />
          <Field
            name="name"
            type="input"
            component={renderBootstrapField}
            label="Name"
            placeholder="Your name"
          />
          <Field
            name="company_name"
            type="input"
            component={renderBootstrapField}
            label="Company Name"
            placeholder="Company Name"
            validate={required}
          />
          <div>
            <Button
              disabled={pristine || submitting}
              bsStyle="default"
              type="submit"
            >
            Register
            </Button>
          </div>
        </form>
      </div>
  )}
  />
);

export default RegisterHotelForm;



// WEBPACK FOOTER //
// src/routes/hotels/components/RegisterHotelForm.js